import { render, staticRenderFns } from "./training-costs.vue?vue&type=template&id=468e269c"
import script from "./training-costs.vue?vue&type=script&lang=js"
export * from "./training-costs.vue?vue&type=script&lang=js"
import style0 from "./training-costs.vue?vue&type=style&index=0&id=468e269c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports